import React from 'react';
import {
  ContactMeSection,
  EducationSection,
  ExperienceSection,
  ScrollDownElement,
  HeroSection,
  ServicesSection,
  TechnologiesSection
} from './sections';
import { Analytics } from '@vercel/analytics/react';

export const App = () => {
  return (
    <div className='tw-checked-background'>
      <div className='max-w-[48rem] flex flex-col gap-8 mx-auto p-4 md:p-12 md:gap-12'>
        <HeroSection />
        <ExperienceSection />
        <EducationSection />
        <TechnologiesSection />
        <ServicesSection />
        <ScrollDownElement />
        <ContactMeSection />
        <Analytics />
      </div>
    </div>
  );
};
